import './styles.css';


angular.module(module.exports = 'ttb.issue.workLogDetails.workLogActivity', [
    require("./work-log.component"),
    require("./work-log-activity.component")
]);



// WEBPACK FOOTER //
// ./components/work-log-activity/index.js